









import {Component, Prop, Vue} from "vue-property-decorator"
import DataGrid, {DataType} from "@/components/DataGrid.vue"
import LoadingSpinner from "@/components/LoadingSpinner.vue"
import appConfig from "@/config"
import {executeQuery} from "@/data/repos/query"
import {formatNumberWithGrouping} from "@/data/sources/numbers"

interface AppraisalItems {
  surveyId: number,
  facetId: number,
  categoryId: number,
  elementId: number,
  subelementId: number
}

function getLink(args: { locationId: number, riskId: number, aprItems: AppraisalItems }) {
  return Vue.component('el-link', {
    functional: true,
    render: function(createElement, ctx) {
      const row = ctx.props.parameters.row
      const href = `${appConfig.IPR_BASE_URL}/pages/condition/conditionreport2.asp?` +
        `id=${encodeURIComponent(row.buildingId)}` +
        `&surveyid=${encodeURIComponent(row.surveyId)}` +
        `&facetid=${encodeURIComponent(row.facetId)}` +
        `&highlight=${encodeURIComponent(row.subelementId)}`
      return createElement('div', {
          style: {
            cursor: "pointer",
          },
          on: {click: (event: any) => window.open(href, "_blank")},
        },
        String(ctx.props.parameters.row[ctx.props.parameters.fName] || ""))
    },
    props: {
      parameters: Object,
    },
  })
}

@Component({
  components: {
    LoadingSpinner,
    DataGrid,
  },
})
export default class AppraisalRiskDrillDown2 extends Vue {
  @Prop() public args!: { locationId: number, row: any, riskId: number, riskLabel: string, aprItems: AppraisalItems }
  private data: any[] | null = null
  private surveyName = ""
  private dataGridFields = [
    {name: 'locationPath', title: 'Location', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'facetname', title: 'Facet', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'categoryName', title: 'Category', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'elementName', title: 'Major Element', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'subelementName', title: 'Subelement', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'conditionRating', title: 'Rating', dataType: DataType.Text, sort: 1, component: getLink(this.args)},
    {name: 'CostToB', title: 'Cost to B', dataType: DataType.Number, sort: 1, component: getLink(this.args)},
    {
      name: 'inspectionDate',
      title: 'Inspection date',
      dataType: DataType.Date,
      sort: 1,
      component: getLink(this.args),
    },
  ]

  public async created() {
    this.getData()
    this.surveyName = this.args.aprItems.subelementId ? "Subelement" :
      this.args.aprItems.elementId ? "Major element" :
        this.args.aprItems.categoryId ? "Category" :
          this.args.aprItems.facetId ? "Facet" :
            this.args.aprItems.surveyId ? "Survey" : ""
  }

  public async getData(offset = 0, count?: number) {
    if (offset) {
      return []
    }
    return await this.loadData(this.args.locationId, this.args.riskId, this.args.aprItems)
  }

  private async loadData(locationId: number, riskId: number, aprItems: AppraisalItems): Promise<any[] | null> {
    const queryName = aprItems.subelementId ? "appraisal.risk.riskDrillDownDetail_subelement" :
      aprItems.elementId ? "appraisal.risk.riskDrillDownDetail_element" :
        aprItems.categoryId ? "appraisal.risk.riskDrillDownDetail_category" :
          aprItems.facetId ? "appraisal.risk.riskDrillDownDetail_facet" :
            aprItems.surveyId ? "appraisal.risk.riskDrillDownDetail_survey" : null
    const args: any = aprItems.subelementId ? {subelementId: aprItems.subelementId} :
      aprItems.elementId ? {elementId: aprItems.elementId} :
        aprItems.categoryId ? {categoryId: aprItems.categoryId} :
          aprItems.facetId ? {facetId: aprItems.facetId} :
            aprItems.surveyId ? {surveyId: aprItems.surveyId} : null
    args.locationId = locationId
    args.riskId = riskId

    if (queryName) {
      return executeQuery("idr", queryName, args, this.filter)
    }
    return []
  }

  private filter(data: any[]): any[] {
    return data.map((v) => {
      return {
        ...v,
        locationPath: `${v.regionname} / ${v.sitename} / ${v.buildingname}`,
        CostToB: v.CostToB === undefined ? "N/A" : `£ ${formatNumberWithGrouping(v.CostToB, 0)}`,
        inspectionDate: dateFmt(v.inspectionDate),
        buildingId: v.buildingid,
        surveyId: v.surveyid,
        facetId: v.facetid,
        categoryId: v.categoryID,
        elementId: v.elementID,
        subelementId: v.subelementid,
      }
    })
  }
}

function dateFmt(dateString: string): string {
  try {
    const dateParts = dateString.trim().split('T')[0].split('-')
    return `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`
  } catch (e) {
    return dateString
  }
}

